<template>
  <div class="imgBox">
   <input  v-if="upURL" type="file" @change="change" accept="image/*" :multiple="multiple" capture="user" >
   <input v-else type="file" @change="change" accept="image/*" :multiple="multiple">
  </div>
</template>
<script type="text/javascript">
import util from '../utils/util.js'
import Exif from 'exif-js'
import { serversHttp } from '../utils/api.js'
var canvas = document.createElement('canvas');
var ctx = canvas.getContext('2d');
// 瓦片canvas
var tCanvas = document.createElement('canvas');
var tctx = tCanvas.getContext('2d');
export default {
  props: {
    multiple:{
      type:Boolean,
      default:false
    },
    upURL:{
      type:String,
      default:''
    }
  },
  data () {
    return {
      maxsize: 1000 * 1024
    };
  },
  created () {},
  methods: {
    change (val) {
      util.showLoading('上传中...')
      let that = this;
      let Orientation = '';
      let mess = val.target.files;
      var files = Array.prototype.slice.call(mess);
      if (files.length > 9) {
        util.showToast('最多同时只可上传9张图片')
        return false;
      }
      files.forEach(function (file, i) {
        if (!/\/(?:jpeg|png|gif)/i.test(file.type)) return;
        //去获取拍照时的信息，解决拍出来的照片旋转问题
        Exif.getData(file, function(){
          Orientation = Exif.getTag(this, 'Orientation');
        });
        var reader = new FileReader();
        reader.onload = function () {
          var result = this.result;
          if(that.upURL){
            that.$emit('changeloaclImg', this.result)
          }
          var img = new Image();
          img.src = result;
          // 如果图片大小小于1000kb，则直接上传
          if (result.length <= that.maxsize && !this.upURL) {
            img = null;
            that.upload(result, file.type);
            return;
          }
          //图片加载完毕之后进行压缩，然后上传
          if (img.complete) {
            callback();
          } else {
            img.onload = callback;
          }
          function callback () {
            var data = that.compress(img,Orientation);
            that.upload(data, file.type);
            img = null;
          }
        };
        reader.readAsDataURL(file);
      })
    },
    // 图片上传，将base64的图片转成二进制对象，塞进formdata上传
    upload (basestr, type) {
      var text = window.atob(basestr.split(',')[1]);
      var buffer = new Uint8Array(text.length);
      for (var i = 0; i < text.length; i++) {
        buffer[i] = text.charCodeAt(i);
      }
      var blob = this.getBlob([buffer], type);
      var formdata = new FormData();
      formdata.append('file', blob);// 传文件
      var url =''
      if(this.upURL){
        url =this.upURL;
      }else{
        url =serversHttp + 'servers.api/fileApi/uploadFile'
      }
      fetch(url, {
        method: 'post',
        body: formdata
      }).then(response => response.json()).then(res => {
        if (res.res && res.res.code === 10000) {
          this.$emit('uploadImg', res.body)
        } else {
          util.showToast('图片上传失败')
          util.hideLoading()
        }
        util.hideLoading()
      })
    },
    getBlob (buffer, format) {
      try {
        return new Blob(buffer, {type: format});
      } catch (e) {
        var bb = new (window.BlobBuilder || window.WebKitBlobBuilder || window.MSBlobBuilder)();
        buffer.forEach(function (buf) {
          bb.append(buf);
        });
        return bb.getBlob(format);
      }
    },
    compress (img,Orientation) {
      var width = img.width;
      var height = img.height;
      // 如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      var ratio;
      if ((ratio = width * height / 4000000) > 1) {
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      // 铺底色
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      // 如果图片像素大于100万则使用瓦片绘制
      var count;
      if ((count = width * height / 1000000) > 1) {
        count = ~~(Math.sqrt(count) + 1); // 计算要分成多少块瓦片
        // 计算每块瓦片的宽和高
        var nw = ~~(width / count);
        var nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (var i = 0; i < count; i++) {
          for (var j = 0; j < count; j++) {
            tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      //修复ios上传图片的时候 被旋转的问题
      if(Orientation && Orientation != 1){
        switch(Orientation){
          case 6://需要顺时针（向左）90度旋转
            this.rotateImg(img,'right',canvas);
            break;
          case 8://需要逆时针（向右）90度旋转
            this.rotateImg(img,'left',canvas);
            break;
          case 3://需要180度旋转
            this.rotateImg(img,'right',canvas,2);//转两次
            break;
        }
      }
      // 进行最小压缩
      var ndata = canvas.toDataURL('image/jpeg', 0.6);
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },
    rotateImg (img, dir,canvas,s) {
      s = s || 1;
      const MIN_STEP = 0;
      const MAX_STEP = 3;

      const width = canvas.width || img.width;
      const height = canvas.height || img.height;
      let step = 0;

      if (dir === 'right') {
          step += s;
          step > MAX_STEP && (step = MIN_STEP);
      } else {
          step -= s;
          step < MIN_STEP && (step = MAX_STEP);
      }

      const degree = step * 90 * Math.PI / 180;
      const ctx = canvas.getContext('2d');

      switch (step) {
      case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height, width, height);
          break;
      case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height, width, height);
          break;
      case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0, width, height);
          break;
      default:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          break;
      }
    }
  }
};
</script>
<style lang="less" scoped>
// @import "~styles/common.less";
.imgBox{
  width:100%;
  height:100%;
  input{
    width:100%;
    height:100%;
    display: block;
  }
}
</style>
